import React from 'react';
import { Container, Navbar, Nav } from 'react-bootstrap';
import { Link, NavLink } from 'react-router-dom';
import logo from '../assets/images/Home/Logo.png';

const Header = () => {
  return (
    <header>
      {/* Top Bar with Contact Info and Social Media */}
      <div className="bg-dark text-light py-2">
        <Container>
          <div className="d-flex justify-content-between align-items-center flex-wrap">
            <div className="d-flex flex-wrap">
              <div className="pe-3 pe-md-5 me-0 me-md-5 mb-2 mb-md-0">
                <i className="bi bi-geo-alt-fill me-2" style={{ color: '#e4880f' }}></i>
                <span className="d-none d-sm-inline">2231 Sample address here, 1010</span>
                <span className="d-inline d-sm-none">2231 Sample address...</span>
              </div>
              <div className="pe-3 pe-md-5 me-0 me-md-5 mb-2 mb-md-0">
                <i className="bi bi-envelope-fill me-2" style={{ color: '#e4880f' }}></i>
                <a href="mailto:info@fabxpert.com" className="text-light">info@fabxpert.com</a>
              </div>
              <div className="mb-2 mb-md-0">
                <i className="bi bi-telephone-fill me-2" style={{ color: '#e4880f' }}></i>
                <a href="tel:+1234056789" className="text-light">+1 234 056 78 90</a>
              </div>
            </div>
            <div className="social-icons mt-2 mt-md-0">
              <a href="#" className="text-light me-3"><i className="bi bi-facebook"></i></a>
              <a href="#" className="text-light me-3"><i className="bi bi-tiktok"></i></a>
              <a href="#" className="text-light me-3"><i className="bi bi-linkedin"></i></a>
              <a href="#" className="text-light me-3"><i className="bi bi-instagram"></i></a>
              <a href="#" className="text-light me-3"><i className="bi bi-twitter-x"></i></a>
              <a href="#" className="text-light"><i className="bi bi-youtube"></i></a>
            </div>
          </div>
        </Container>
      </div>

      {/* Main Navigation */}
      <Navbar bg="white" expand="lg" className="py-1">
        <Container className="d-flex justify-content-between align-items-center">
          <Navbar.Brand as={Link} to="/" className="py-2">
            <img src={logo} alt="FabXpert Logo" className='w-logo-header'/>
          </Navbar.Brand>
          
          <Navbar.Toggle aria-controls="navbar-nav" className="border-0 me-0">
            <span className="navbar-toggler-icon"></span>
          </Navbar.Toggle>
          
          <Navbar.Collapse id="navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link as={NavLink} to="/" className="fw-bold" activeClassName="text-warning">Home</Nav.Link>
              <Nav.Link as={NavLink} to="/services" className="fw-bold" activeClassName="text-warning">Services</Nav.Link>
              <Nav.Link as={NavLink} to="/about" className="fw-bold" activeClassName="text-warning">About</Nav.Link>
              <Nav.Link as={NavLink} to="/contact" className="fw-bold" activeClassName="text-warning">Contact</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default Header; 